export default __webpack_public_path__ + "static/media/wisetrack_logo_login.7e4d3a59.png";